// src/components/layout/Footer.jsx
import React from 'react';
import '../../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Art Investment Platform. All rights reserved.</p>
    </footer>
  );
}